<div class="full-screen-loading">
    <div class="loading-container">
        <p class="loading-title">{{ 'app.wizard.stepper_ia.loader.estamos_generando' | translate }}</p>
        <div class="progress-bar-wrapper">
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="progress"></div>
            </div>
        </div>
        <div class="loading-content">
            <div class="loading-icon">
                <img
                    src="{{ assetsUrl }}{{ mfsPath }}/img/front/wizard/sections/Loading-sitio.svg"
                    alt=""
                    class="img-loading"
                />
            </div>
            <div class="loading-text">
                <ul class="loading-steps">
                    <li #stepEl *ngFor="let step of steps; let i = index" [class.done]="i < currentStep" class="step">
                        <i
                            class="icon"
                            [ngClass]="{
                                'fa-solid': true,
                                'fa-check-circle': i < currentStep && i !== steps.length - 1,
                                'fa-circle-notch': i >= currentStep && i !== steps.length - 1,
                                'fa-regular': i === steps.length - 1,
                                'fa-circle': i === steps.length - 1
                            }"
                        ></i>
                        {{ step }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
